// Control de stock del encargado (acciones pendientes del dashboard).
// `sinCaja` porque revisar el stock no requiere caja abierta ni arqueo.
// Alcanza con cualquiera de los dos permisos de control de stock, igual que
// en el backend; el guard gatea la navegacion y la API valida de nuevo.
const meta = { sinCaja: true, permisos: ['realizar_inventario', 'modificar_stock'] };

export default [
  {
    path: 'control-stock',
    name: 'pos.alertas.stock',
    component: () => import('@/views/inventario/AlertasStockControl.vue'),
    meta,
  },
];
